import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  AfterViewInit,
  SimpleChanges,
} from '@angular/core';
import { IconsService } from '../../services/icons.service';
import { NGXLogger } from 'ngx-logger';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../@fuse/pipes/pipes.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StorageService } from '../../../services/storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-top-alerts',
  templateUrl: './top-alerts.component.html',
  styleUrls: ['./top-alerts.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
    MatIconModule,
    NgxPermissionsModule,
    MatTooltipModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
  ],
})
export class TopAlertsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() alerts: TopAlertModel[] = [];
  visibleAlerts: TopAlertModel[] = [];
  currentLang: string = 'fr-CA';
  private langChangeSub!: Subscription;

  constructor(
    public iconsService: IconsService,
    public logger: NGXLogger,
    private storageService: StorageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.currentLang = this.translate.currentLang || 'fr-CA';
    this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang;
      this.filterDismissedAlerts();
    });
  }

  ngOnDestroy() {
    this.langChangeSub?.unsubscribe();
  }

  ngAfterViewInit() {
    this.filterDismissedAlerts();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['alerts'] && changes['alerts'].currentValue) {
      this.filterDismissedAlerts();
    }
  }

  getLocalized(field: Record<string, string>): string {
    if (!field) return '';
    const prefix = this.currentLang.split('-')[0];
    return field[this.currentLang] || field[prefix] || Object.values(field)[0] || '';
  }

  private filterDismissedAlerts() {
    const dismissedUuids: string[] =
      this.storageService.getData('dismissedAlertUuids') || [];
    this.visibleAlerts = (this.alerts || []).filter(
      (alert) => this.getLocalized(alert.message) && !dismissedUuids.includes(alert.uuid),
    );
  }

  public onHideAlert(alert: TopAlertModel): void {
    const dismissedUuids: string[] =
      this.storageService.getData('dismissedAlertUuids') || [];
    this.storageService.saveData('dismissedAlertUuids', [
      ...dismissedUuids,
      alert.uuid,
    ]);
    this.visibleAlerts = this.visibleAlerts.filter(
      (a) => a.uuid !== alert.uuid,
    );
  }
}

export interface TopAlertModel {
  uuid: string;
  message: Record<string, string>;
  message_color: string;
  background_color: string;
  message_closable: boolean;
  elevation: boolean;
  message_url_label: Record<string, string>;
  message_url: string;
  message_url_target: string;
  icon: string;
}
